import type { SVGProps } from "react";

export default function OrganizationIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M18.3332 18.5098H1.6665"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M14.1663 18.5102V5.17684C14.1663 3.60549 14.1663 2.81981 13.6782 2.33166C13.19 1.84351 12.4043 1.84351 10.833 1.84351H9.16634C7.59499 1.84351 6.80932 1.84351 6.32117 2.33166C5.83301 2.81981 5.83301 3.60549 5.83301 5.17684V18.5102"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M17.5002 18.5104V9.76042C17.5002 8.59 17.5002 8.00484 17.2192 7.58447C17.0977 7.40248 16.9414 7.24623 16.7594 7.12463C16.3391 6.84375 15.7539 6.84375 14.5835 6.84375"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M2.5 18.5104V9.76042C2.5 8.59 2.5 8.00484 2.78088 7.58447C2.90248 7.40248 3.05873 7.24623 3.24072 7.12463C3.66109 6.84375 4.24628 6.84375 5.41667 6.84375"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M10 18.5098V16.0098"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M8.3335 4.34351H11.6668"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M8.3335 6.84375H11.6668"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M8.3335 9.34326H11.6668"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M8.3335 11.8435H11.6668"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
    </svg>
  );
}
